__turbopack_context__.v({
  "className": "Ie2Dqa_className",
  "variable": "Ie2Dqa_variable",
});
